// extracted by mini-css-extract-plugin
export default {"melodyVideo":"QO-z","isFullWidth":"RO-z","landingPageVideo":"SO-z","play":"TO-z","iframeVideo":"UO-z","playHidden":"VO-z","fullwidth":"WO-z"};